import { useRouter } from "@tanstack/react-router";
import { AlertTriangle, FileQuestion } from "lucide-react";

import { Button } from "@/components/ui/Button";

const ERROR_CONTENT = {
  notFound: {
    icon: FileQuestion,
    title: "페이지를 찾을 수 없습니다",
    description: "요청하신 페이지가 존재하지 않거나 이동되었습니다.",
  },
  error: {
    icon: AlertTriangle,
    title: "일시적인 오류가 발생했습니다",
    description: "잠시 후 다시 시도해 주세요.",
  },
} as const;

type ErrorType = keyof typeof ERROR_CONTENT;

interface ErrorPageProps {
  type?: ErrorType;
}

const ErrorPage = ({ type = "error" }: ErrorPageProps) => {
  const router = useRouter();
  const { icon: IconComponent, title, description } = ERROR_CONTENT[type];

  const handleGoHome = () => {
    void router.navigate({ to: "/dashboard" });
  };

  const handleGoBack = () => {
    router.history.back();
  };

  return (
    <div className="flex h-full items-center justify-center p-8">
      <div className="flex max-w-sm flex-col items-center text-center">
        <div className="flex size-16 items-center justify-center rounded-full bg-muted">
          <IconComponent className="size-8 text-muted-foreground" />
        </div>

        <h2 className="mt-6 text-lg font-semibold text-foreground">{title}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{description}</p>

        <div className="mt-8 flex gap-3">
          <Button variant="default" onClick={handleGoBack}>
            이전 페이지
          </Button>
          <Button variant="primary" onClick={handleGoHome}>
            홈으로
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
